import { useDetails } from '@/src/hooks/useDetails';
import { AuthApi, Credentials } from '@/src/lib/SmartDB/lib/Auth/index';
import { useAppStore, useWalletStore } from '@/src/store/global/index';
import { TxComponentProps } from '@/src/types/index';
import { useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';

export const useModalGetApiToken = () => {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const loadDetails = async () => {
        let token: string | undefined;
        const lucid = await walletStore.getLucid();
        if (status === 'authenticated' && lucid !== undefined && session && session.user && apiToken === '') {
            const credentials: Credentials = {
                address: session.user.address,
                walletName: session.user.walletName,
                walletKey: session.user.walletKey,
                walletSeed: session.user.walletSeed,
                useBlockfrostToSubmit: session.user.useBlockfrostToSubmit ? 'true' : 'false',
                isWalletFromSeed: session.user.isWalletFromSeed ? 'true' : 'false',
                isWalletFromKey: session.user.isWalletFromKey ? 'true' : 'false',
            };
            //--------------------------------------
            token = await AuthApi.generateAuthTokensApi(lucid, credentials, true);
        }
        return token;
    };
    //--------------------------------------
    function checkDependencies() {
        let doLoadDetails = false;
        if (isOpen === true) {
            doLoadDetails = true;
        }
        return doLoadDetails;
    }
    //--------------------------------------
    const [isOpen, setIsOpen] = useState(false);
    //--------------------------------------
    const { isLoadingDetails, isLoadedDetails, current } = useDetails<string>({
        nameDetails: 'Api Token',
        loadDetails,
        checkDependencies,
        dependencies: [isOpen],
    });
    //--------------------------------------
    const handleOpen = () => {
        setIsOpen(true);
    };
    const handleClose = () => setIsOpen(false);
    //--------------------------------------
    const { data: session, status } = useSession();
    //--------------------------------------
    const [apiToken, setApiToken] = useState('');
    const [isReady, setIsReady] = useState(false);
    //--------------------------------------
    const walletStore = useWalletStore();
    //--------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    useEffect(() => {
        if (current !== undefined) {
            setApiToken(current);
        }
    }, [current]);
    //--------------------------------------
    useEffect(() => {
        if (status === 'authenticated' && walletStore.isConnected === true) {
            setIsReady(true);
        }
    }, [status, walletStore.isConnected]);
    //--------------------------------------
    const txComponentProps: TxComponentProps = {
        onTx: async () => {
            appStore.setIsProcessingTx(false);
            setIsOpen(false);
        },
        onCancel: async () => {
            setIsOpen(false);
        },
    };
    //--------------------------------------
    return {
        isRefreshing,
        isReady,
        isLoadedDetails,
        isLoadingDetails,
        apiToken,
        isOpen,
        handleOpen,
        handleClose,
        txComponentProps,
    };
    //--------------------------------------
};
